@if (data$ | async; as data) {
  <div class="video-container" tabindex="-1">
    @if (data.overlayTitle) {
      <a [routerLink]="routerLink">{{ data.overlayTitle }}</a>
    }
    @if (source) {
      <video
        [style.height.px]="data.videoContainerHeight"
        controls
        [poster]="thumbnail?.src"
        [loop]="loop"
        [autoplay]="autoPlay"
        [muted]="mute"
        [attr.aria-label]="'player.label' | cxTranslate"
        [src]="source"
      ></video>
    }
  </div>
} @else {
  <div class="cx-spinner"><cx-spinner></cx-spinner></div>
}

